module.exports = __webpack_public_path__ + "img/verify-email.5ad6765f.svg";